<a [routerLink]="participantRoute$ | async">
  <ng-content />
</a>
